/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import { findChild, getChildren, type VdomChildren, type VdomParent } from '../../common/utils/vdom';
import type Mithril from 'mithril';

declare module 'flarum/forum/components/DiscussionListItem' {
	export default interface DiscussionListItem {
		/**
		 * The `tags` info item, pulled out of `infoItems()` so that `view()` can
		 * render it in its own row instead.
		 */
		infoItemsTags?: Mithril.Children;
	}
}

export default function () {
	extend(DiscussionListItem.prototype, 'infoItems', function (items) {
		if (items.has('tags')) {
			this.infoItemsTags = items.get('tags');
			items.remove('tags');
		}
	});

	extend(DiscussionListItem.prototype, 'view', function (vnode) {
		try {
			const tags = this.infoItemsTags;

			const DiscussionListItem_main = findChild(vnode as unknown as VdomParent, 'DiscussionListItem-main', true)!;

			DiscussionListItem_main.children = [
				<div className="DiscussionListItem-tags">{tags}</div>,
				...getChildren(DiscussionListItem_main),
			] as VdomChildren;
		} catch (e) {}
	});
}
